module.exports = __webpack_public_path__ + "img/2.bfb7644d.png";